import { render, staticRenderFns } from "./BlwTooltip.vue?vue&type=template&id=70f2c8c3&"
import script from "./BlwTooltip.vue?vue&type=script&lang=js&"
export * from "./BlwTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports